import { useNavigate } from "react-router";
import image1 from "/public/assets/images/Group 70.svg";
import image2 from "/public/assets/images/Black.svg";
import image3 from "/public/assets/images/Black1.svg";

import image4 from "../../assets/icons/noun-contact-7300401 copy.png";
import useAuth from "@hooks/useAuth";
import { GoFile } from "react-icons/go";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import {
  getAllBmas,
  getAllIcps,
  getAllVps,
  getCicProfileById,
  IcpProfile,
  VpsProfile,
} from "@redux/slices/strategicPlanning";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import LoadingScreen from "@components/LoadingScreen";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...theme.applyStyles("dark", {
      backgroundColor: "#308fe8",
    }),
  },
}));

const StrategicPlanning = () => {
  const navigate = useNavigate();
  const [icps, setIcps] = useState<boolean>();
  const [vps, setVps] = useState<boolean>();
  const [bma, setBma] = useState<boolean>();
  const [cic, setCic] = useState<boolean>();
  const [icpsData, setIcpsData] = useState<IcpProfile[]>();
  const [vpsData, setVpsData] = useState<VpsProfile[]>();
  const [bmaData, setBmaData] = useState<VpsProfile[]>();
  const [cicData, setCicData] = useState();
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const getData = async () => {
    const icps = await getAllIcps(user?.id);
    const vps = await getAllVps(user?.id);
    const bma = await getAllBmas(user?.id);
    const cic = await getCicProfileById(user?.id);

    setIcpsData(icps || []);
    setVpsData(vps || []);
    setBmaData(bma || []);
    setCicData(cic || undefined);

    const icpStatus =
      icps?.some((item) => item.status === "completed") ?? false;
    const vpsStatus = vps?.some((item) => item.status === "completed") ?? false;
    const bmaStatus = bma?.some((item) => item.status === "completed") ?? false;

    const icpFiltered = icps?.filter((i) => i.status === "completed") ?? [];
    const vpsFiltered = vps?.filter((i) => i.status === "completed") ?? [];
    const bmaFiltered = bma?.filter((i) => i.status === "completed") ?? [];

    setIcps(icpStatus);
    setVps(vpsStatus);
    setBma(bmaStatus);
    setCic(cic?.status == "completed" ? true : false);
    console.log(cic,cicData);

    // const icpProgress = icps ? (icpFiltered.length / icps.length) * 100 : 0;
    // const vpsProgress = vps ? (vpsFiltered.length / vps.length) * 100 : 0;
    // const bmaProgress = bma ? (bmaFiltered.length / bma.length) * 100 : 0;

    // setIcpsProgress(icpProgress);
    // setVpsProgress(vpsProgress);
    // setBmaProgress(bmaProgress);

    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          {/* <h2 className="text-gray font-bold sm:text-[22px] text-lg xl:mb-0 mb-5">
            Select From Type
          </h2> */}
          <div className="flex gap-10 mt-5">
            <div
              className="w-1/3 h-100 flex flex-col justify-between text-center p-5 bg-white rounded-lg cursor-pointer"
              onClick={() =>
                navigate(
                  user?.role !== "admin"
                    ? `/strategicPlanning/icps/${user.id}`
                    : "/spUsers/icp"
                )
              }
            >
              <div>
                <BorderLinearProgress
                  variant="determinate"
                  value={icps ? 100 : 0}
                />
              </div>
              <div className="flex justify-center my-5">
              <div className="text-[white] rounded-[15px] bg-[#1CB5AF]  w-[130px] mt-2 text-[18px]">
                Phase 1
              </div>
              </div>

              <div className="flex justify-center my-5">
                <img src={image1} alt="" width={56} />
              </div>
              <h4 className="text-lg font-medium mb-5">
                Ideal Customer Profile <br /> (ICP)
              </h4>
              <div className="flex justify-center bottom-0">
                {icpsData && icpsData?.length > 0 ? (
                  icps ? (
                    <p className="text-lg text-[#1CB5AF] font-medium items-center mb-5 mt-5 flex">
                      <IoCheckmarkDoneCircleOutline className="me-2" />{" "}
                      Completed
                    </p>
                  ) : (
                    <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                      <GoFile className="me-2" /> Draft
                    </p>
                  )
                ) : (
                  <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                    No Data
                  </p>
                )}
              </div>
            </div>
            <div
              className="w-1/3 h-100 flex flex-col justify-between text-center p-5 bg-white rounded-lg cursor-pointer"
              onClick={() =>
                navigate(
                  user?.role !== "admin"
                    ? `/strategicPlanning/vps/${user.id}`
                    : "/spUsers/strategicPlanning/vps"
                )
              }
            >
              <BorderLinearProgress
                variant="determinate"
                value={vps ? 100 : 0}
              />

<div className="flex justify-center my-5">
              <div className="text-[white] rounded-[15px] bg-[#1CB5AF]  w-[130px] mt-2 text-[18px]">
                Phase 2
              </div>
              </div>


              <div className="flex justify-center my-5">
                <img src={image2} alt="" />
              </div>
              <h4 className="text-lg font-medium mb-5">
                Value Propositions & Strengths (VPS)
              </h4>
              <div className="flex justify-center">
                {vpsData && vpsData?.length > 0 ? (
                  vps ? (
                    <p className="text-lg text-[#1CB5AF] font-medium mb-5 mt-5 flex items-center">
                      <IoCheckmarkDoneCircleOutline className="me-2" />{" "}
                      Completed
                    </p>
                  ) : (
                    <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                      <GoFile className="me-2" /> Draft
                    </p>
                  )
                ) : (
                  <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                    No Data
                  </p>
                )}
              </div>
            </div>
            <div
              className="w-1/3 h-100 flex flex-col justify-between text-center p-5 bg-white rounded-lg cursor-pointer"
              onClick={() =>
                navigate(
                  user?.role !== "admin"
                    ? `/strategicPlanning/bma/${user.id}`
                    : "/spUsers/strategicPlanning/bma"
                )
              }
            >
              <BorderLinearProgress
                variant="determinate"
                value={bma ? 100 : 0}
              />

<div className="flex justify-center my-5">
              <div className="text-[white] rounded-[15px] bg-[#1CB5AF]  w-[130px] mt-2 text-[18px]">
                Phase 3
              </div>
              </div>

              <div className="flex justify-center my-5">
                <img src={image3} alt="" />
              </div>
              <h4 className="text-lg font-medium mb-5">
                Business Model & Market Analysis (BMA)
              </h4>
              <div className="flex justify-center">
                {bmaData && bmaData?.length > 0 ? (
                  bma ? (
                    <p className="text-lg text-[#1CB5AF] font-medium mb-5 mt-5 flex items-center">
                      <IoCheckmarkDoneCircleOutline className="me-2" />{" "}
                      Completed
                    </p>
                  ) : (
                    <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                      <GoFile className="me-2" /> Draft
                    </p>
                  )
                ) : (
                  <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                    No Data
                  </p>
                )}
              </div>
            </div>
            <div
              className="w-1/3 h-100 flex flex-col justify-between text-center p-5 bg-white rounded-lg cursor-pointer"
              onClick={() => navigate("/strategicPlanning/readmeIcp")}
            >
              <BorderLinearProgress
                variant="determinate"
                value={cic ? 100 : 0}
              />

<div className="flex justify-center my-5">
              <div className="text-[white] rounded-[15px] bg-[#1CB5AF]  w-[130px] mt-2 text-[18px]">
                Phase 4
              </div>
              </div>

              <div className="flex justify-center my-5">
                <img src={image4} alt=""  className="h-[85px]"/>
              </div>
              <h4 className="text-lg font-medium mb-5">
              Content for Initial Contact (CIC)
              </h4>
              <div className="flex justify-center">
                {cicData !==undefined ? (
                  cic ? (
                    <p className="text-lg text-[#1CB5AF] font-medium mb-5 mt-5 flex items-center">
                      <IoCheckmarkDoneCircleOutline className="me-2" />{" "}
                      Completed
                    </p>
                  ) : (
                    <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                      <GoFile className="me-2" /> Draft
                    </p>
                  )
                ) : (
                  <p className="text-lg font-medium mb-5 mt-5 flex items-center">
                    Not Read Yet
                  </p>
                )}
              </div>
            </div>
          </div>
          {/* <div className="flex justify-end absolute bottom-12 right-12">
            <Button onClick={()=>navigate("/strategicPlanning/readmeIcp")}>Contact for Initial Content</Button>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default StrategicPlanning;
